export default "__VITE_ASSET__G0c5qt4a__"